import { EyeTwoTone, SyncOutlined } from '@ant-design/icons'
import { makeStyles } from '@material-ui/core'
import { Button, Popconfirm, Space, Table, Tag, message } from 'antd'
import moment from 'moment'
import React from 'react'
import { useData } from '../../../../data'
import { useRouter } from '../../../../routes'



const useStyles = makeStyles(theme => ({
    table: {
        width: '100%',
        marginRight: theme.spacing(1)
    },
    reload: {
        color: 'blue',
        textAlign: 'center'
    },
}))

/**
 * Jobs Table view
 */
const JobTasksTableView = (props) => {
    const classes = useStyles()
    const data = useData()
    const jobs = data.jobs()
    const router = useRouter()

    function onChange(pagination, filters, sorter) {
        if (filters.status) {
            props.setFilter(filters.status)
        } else {
            props.setFilter([])
        }
    }


    const reloadTask = (id) => {
        jobs.restartTask(id)
            .then(() => {
                message.info(`Task restarted successfully.`);
                props.refresh();
            })
            .catch(console.log)
    }

    const taskDetails = (task) => {
        const { id } = task
        router.push(`/dashboard/job/task/details?id=${id}`)
    }

    const changePage = (page, _) => {
        props.updatePage(page);
    }

    const changeSize = (_, size) => {
        props.updateLimit(size)
    }

    // jobs table schema
    const jobsTasksSchema = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => <Button type="link" onClick={() => taskDetails(record)} size="small">{text}</Button>
        },
        {
            title: 'Spider',
            dataIndex: 'spider_name',
            key: 'spider_name'
        },
        {
            title: 'Retries',
            dataIndex: 'retries',
            key: 'retries'
        },
        {
            title: 'Cookie',
            dataIndex: 'cookie_id',
            key: 'cookie_id'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: status => (
                <Tag color={status == 'DONE' ? 'green' : status == 'ERROR' ? 'red' : status == 'PROCESSING' ? 'blue' : ''} key={status}>
                    {status.toUpperCase()}
                </Tag>
            ),
            filters: [
                { text: 'PENDING', value: 'PENDING' },
                { text: 'PROCESSING', value: 'PROCESSING' },
                { text: 'DISPATCH', value: 'DISPATCH' },
                { text: 'PAUSED', value: 'PAUSED' },
                { text: 'TERMINATED', value: 'TERMINATED' },
                { text: 'DONE', value: 'DONE' },
                { text: 'ERROR', value: 'ERROR' },
                { text: 'RETRIED', value: 'RETRIED' },
            ],
            onFilter: (value, record) => record.status.indexOf(value) === 0,
            sorter: (a, b) => a.status.length - b.status.length,
            sortDirections: ['descend'],
        },
        {
            title: 'Created at',
            dataIndex: 'created_at',
            key: 'created_at',
            render: created_at => (
                moment(created_at).format("YYYY-MM-DD HH:mm")
            ),
        },
        {
            title: 'Updated at',
            dataIndex: 'updated_at',
            key: 'updated_at',
            render: updated_at => (
                moment(updated_at).format("YYYY-MM-DD HH:mm")
            ),
        },
        {
            title: 'Action',
            key: 'actions',
            render: (text, record) => (
                <Space>
                    <EyeTwoTone style={{ fontSize: 20 }} onClick={() => taskDetails(record)} />
                    <Popconfirm title="Are you sure?" onConfirm={() => reloadTask(record.id)}>
                        <SyncOutlined className={classes.reload} />
                    </Popconfirm>
                </Space>
            ),
        }

    ]

    if (props.job_type == "scrapy") {
        jobsTasksSchema.splice(2, 0, {
            title: 'Scrapyd URL',
            dataIndex: 'scrapyd_url',
            key: 'scrapyd_url',
            render: (text, record) =>
                <a target='_blank' href={`${record.scrapyd_url}/logs/default/${record.spider_name}/${record.scrapyd_task_id}.log`}>{record.scrapyd_url}</a>
        })
    } else {
        jobsTasksSchema.splice(2, 0, {
            title: 'Celery Task ID',
            dataIndex: 'scrapyd_url',
            key: 'scrapyd_url',
            render: (text, record) =>
                <Button type="link" onClick={() => taskDetails(record)} size="small">{record.scrapyd_url}</Button>
        })
    }

    return (
        <>
            <h2> Job Tasks </h2>
            <Table
                columns={jobsTasksSchema}
                dataSource={props.job_tasks}
                className={classes.table}
                size="small"
                onChange={onChange}
                pagination={{
                    onChange: changePage,
                    onShowSizeChange: changeSize,
                    showSizeChanger: true,
                    total: props.count,
                    current: props.currentPage,
                    pageSize: props.limit,
                }}
            />
        </>
    )
}

export default JobTasksTableView
